import React from 'react'
import MessagesSvg from 'images/modules/Manage/i-menu-messages.svg?raw'

export { default as MessagesUrl } from 'images/modules/Manage/i-menu-messages.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: MessagesSvg}} />
)
